/* tslint:disable */
/* eslint-disable */
/**
 * az-document
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 5.0.8-RELEASE 2022-08-11T07:20:24Z
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * The value to be parsed by the operator
 * @export
 * @interface AbstractDateSearchValue
 */
export interface AbstractDateSearchValue {
    /**
     * 
     * @type {string}
     * @memberof AbstractDateSearchValue
     */
    '@class': string;
}
/**
 * 
 * @export
 * @interface AssignBundleRequest
 */
export interface AssignBundleRequest {
    /**
     * The ids of documents
     * @type {Set<string>}
     * @memberof AssignBundleRequest
     */
    'ids': Set<string>;
    /**
     * The id of bundle
     * @type {string}
     * @memberof AssignBundleRequest
     */
    'bundleId': string;
    /**
     * Origin of documents
     * @type {string}
     * @memberof AssignBundleRequest
     */
    'origin'?: string;
}
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof Attachment
     */
    'headers'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {object}
     * @memberof Attachment
     */
    'object'?: object;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'contentId'?: string;
    /**
     * 
     * @type {ContentDisposition}
     * @memberof Attachment
     */
    'contentDisposition'?: ContentDisposition;
    /**
     * 
     * @type {AttachmentDataHandler}
     * @memberof Attachment
     */
    'dataHandler'?: AttachmentDataHandler;
    /**
     * 
     * @type {AttachmentContentType}
     * @memberof Attachment
     */
    'contentType'?: AttachmentContentType;
}
/**
 * 
 * @export
 * @interface AttachmentContentType
 */
export interface AttachmentContentType {
    /**
     * 
     * @type {string}
     * @memberof AttachmentContentType
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentContentType
     */
    'subtype'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AttachmentContentType
     */
    'parameters'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentContentType
     */
    'wildcardType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentContentType
     */
    'wildcardSubtype'?: boolean;
}
/**
 * 
 * @export
 * @interface AttachmentDataHandler
 */
export interface AttachmentDataHandler {
    /**
     * 
     * @type {AttachmentDataHandlerDataSource}
     * @memberof AttachmentDataHandler
     */
    'dataSource'?: AttachmentDataHandlerDataSource;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandler
     */
    'name'?: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentDataHandler
     */
    'inputStream'?: object;
    /**
     * 
     * @type {object}
     * @memberof AttachmentDataHandler
     */
    'content'?: object;
    /**
     * 
     * @type {AttachmentDataHandlerCommandMap}
     * @memberof AttachmentDataHandler
     */
    'commandMap'?: AttachmentDataHandlerCommandMap;
    /**
     * 
     * @type {Array<AttachmentDataHandlerTransferDataFlavorsInner>}
     * @memberof AttachmentDataHandler
     */
    'transferDataFlavors'?: Array<AttachmentDataHandlerTransferDataFlavorsInner>;
    /**
     * 
     * @type {Array<AttachmentDataHandlerPreferredCommandsInner>}
     * @memberof AttachmentDataHandler
     */
    'preferredCommands'?: Array<AttachmentDataHandlerPreferredCommandsInner>;
    /**
     * 
     * @type {Array<AttachmentDataHandlerPreferredCommandsInner>}
     * @memberof AttachmentDataHandler
     */
    'allCommands'?: Array<AttachmentDataHandlerPreferredCommandsInner>;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandler
     */
    'contentType'?: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentDataHandler
     */
    'outputStream'?: object;
}
/**
 * 
 * @export
 * @interface AttachmentDataHandlerCommandMap
 */
export interface AttachmentDataHandlerCommandMap {
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentDataHandlerCommandMap
     */
    'mimeTypes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AttachmentDataHandlerDataSource
 */
export interface AttachmentDataHandlerDataSource {
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerDataSource
     */
    'name'?: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentDataHandlerDataSource
     */
    'inputStream'?: object;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerDataSource
     */
    'contentType'?: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentDataHandlerDataSource
     */
    'outputStream'?: object;
}
/**
 * 
 * @export
 * @interface AttachmentDataHandlerPreferredCommandsInner
 */
export interface AttachmentDataHandlerPreferredCommandsInner {
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerPreferredCommandsInner
     */
    'commandClass'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerPreferredCommandsInner
     */
    'commandName'?: string;
}
/**
 * 
 * @export
 * @interface AttachmentDataHandlerTransferDataFlavorsInner
 */
export interface AttachmentDataHandlerTransferDataFlavorsInner {
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'humanPresentableName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'primaryType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassInputStream'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassByteBuffer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorTextType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassReader'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassCharBuffer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassSerializable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassRemote'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'mimeTypeSerializedObject'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'defaultRepresentationClassAsString'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorSerializedObjectType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorRemoteObjectType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorJavaFileListType'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'subType'?: string;
}
/**
 * 
 * @export
 * @interface BaseDocumentMetadataRequest
 */
export interface BaseDocumentMetadataRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof BaseDocumentMetadataRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'status'?: Array<string>;
    /**
     * Filter raed or unread documents
     * @type {boolean}
     * @memberof BaseDocumentMetadataRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents whiteout filter
     * @type {boolean}
     * @memberof BaseDocumentMetadataRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'externalUrl'?: string;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof BaseDocumentMetadataRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof BaseDocumentMetadataRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof BaseDocumentMetadataRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     * 
     * @type {TextSearchParamFilter}
     * @memberof BaseDocumentMetadataRequest
     */
    'textSearch'?: TextSearchParamFilter;
}
/**
 * 
 * @export
 * @interface ChangeStatusRequest
 */
export interface ChangeStatusRequest {
    /**
     * 
     * @type {Set<string>}
     * @memberof ChangeStatusRequest
     */
    'documentIds': Set<string>;
    /**
     * 
     * @type {string}
     * @memberof ChangeStatusRequest
     */
    'status': string;
}
/**
 * CommunicationBean (ComplexMetadata)
 * @export
 * @interface CommunicationMetadataBean
 */
export interface CommunicationMetadataBean extends SimpleMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof CommunicationMetadataBean
     */
    'practiceType'?: string;
}
/**
 * 
 * @export
 * @interface CommunicationMetadataBeanAllOf
 */
export interface CommunicationMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof CommunicationMetadataBeanAllOf
     */
    'practiceType'?: string;
}
/**
 * Additional metadata infos of the document
 * @export
 * @interface ComplexMetadata
 */
export interface ComplexMetadata {
    /**
     * 
     * @type {string}
     * @memberof ComplexMetadata
     */
    '@class': string;
}
/**
 * Contacts to send notification email to
 * @export
 * @interface ContactInfoBean
 */
export interface ContactInfoBean {
    /**
     * The id of contactInfo
     * @type {string}
     * @memberof ContactInfoBean
     */
    'id'?: string;
    /**
     * The channel of communication
     * @type {string}
     * @memberof ContactInfoBean
     */
    'channel'?: string;
    /**
     * The language of communication
     * @type {string}
     * @memberof ContactInfoBean
     */
    'language'?: string;
    /**
     * The email to send communication
     * @type {string}
     * @memberof ContactInfoBean
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface ContentDisposition
 */
export interface ContentDisposition {
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'type'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ContentDisposition
     */
    'parameters'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'filename'?: string;
}
/**
 * metadata of contract documents
 * @export
 * @interface ContractMetadataBean
 */
export interface ContractMetadataBean extends FeqMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'practiceType'?: string;
    /**
     * documentData from signroom
     * @type {boolean}
     * @memberof ContractMetadataBean
     */
    'signroom': boolean;
    /**
     * Document Type for Strongdox
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'documentClass'?: string;
    /**
     * The id of contract for Volumen
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'contractId'?: string;
}
/**
 * 
 * @export
 * @interface ContractMetadataBeanAllOf
 */
export interface ContractMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * documentData from signroom
     * @type {boolean}
     * @memberof ContractMetadataBeanAllOf
     */
    'signroom'?: boolean;
    /**
     * Document Type for Strongdox
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'documentClass'?: string;
    /**
     * The id of contract for Volumen
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'contractId'?: string;
}
/**
 * Filter by document expiration date
 * @export
 * @interface DateSearchParamFilter
 */
export interface DateSearchParamFilter {
    /**
     * The operator to be applied on the field
     * @type {string}
     * @memberof DateSearchParamFilter
     */
    'operator': DateSearchParamFilterOperatorEnum;
    /**
     * 
     * @type {AbstractDateSearchValue}
     * @memberof DateSearchParamFilter
     */
    'value': AbstractDateSearchValue;
    /**
     * The name of the field to be filtered
     * @type {string}
     * @memberof DateSearchParamFilter
     */
    'field': string;
}

export const DateSearchParamFilterOperatorEnum = {
    Before: 'BEFORE',
    BeforeOrEqual: 'BEFORE_OR_EQUAL',
    After: 'AFTER',
    AfterOrEqual: 'AFTER_OR_EQUAL',
    Between: 'BETWEEN',
    EqualsTimestamp: 'EQUALS_TIMESTAMP'
} as const;

export type DateSearchParamFilterOperatorEnum = typeof DateSearchParamFilterOperatorEnum[keyof typeof DateSearchParamFilterOperatorEnum];

/**
 * 
 * @export
 * @interface DeleteDocumentRequest
 */
export interface DeleteDocumentRequest {
    /**
     * The id list of the documents to delete
     * @type {Set<string>}
     * @memberof DeleteDocumentRequest
     */
    'ids'?: Set<string>;
    /**
     * The owner of the document to delete
     * @type {string}
     * @memberof DeleteDocumentRequest
     */
    'ownerCode'?: string;
    /**
     * The type of the document to delete. It must be used with another parameter (e.g. if ownerCode parameter is not empty then documentType can be used)
     * @type {string}
     * @memberof DeleteDocumentRequest
     */
    'documentType'?: string;
    /**
     * Document id list of documents in the document store to delete
     * @type {Set<string>}
     * @memberof DeleteDocumentRequest
     */
    'dmsIds'?: Set<string>;
}
/**
 * Disposition Data (ComplexMetadata), complexMetadata used for digital sign flows
 * @export
 * @interface DispositionMetadataBean
 */
export interface DispositionMetadataBean extends FeqMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'practiceType'?: string;
    /**
     * documentData from signroom
     * @type {boolean}
     * @memberof DispositionMetadataBean
     */
    'signroom': boolean;
    /**
     * Document Type for Strongdox
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'documentClass'?: string;
    /**
     * The id of contract for Volumen
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'contractId'?: string;
    /**
     * Financial plan id
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'planId'?: string;
    /**
     * Service Type Code
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'serviceTypeCode': string;
    /**
     * Report ID
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportMasterId'?: string;
    /**
     * Report Category
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportCategory'?: string;
    /**
     * Report type
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportType'?: string;
    /**
     * Module ID
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'moduleId'?: string;
    /**
     * Order list
     * @type {Array<OrderMetadataBean>}
     * @memberof DispositionMetadataBean
     */
    'orders'?: Array<OrderMetadataBean>;
    /**
     * Total amount
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'totalAmount'?: string;
    /**
     * Total Amount Currency
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'totalAmountCurrency'?: string;
}
/**
 * 
 * @export
 * @interface DispositionMetadataBeanAllOf
 */
export interface DispositionMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * documentData from signroom
     * @type {boolean}
     * @memberof DispositionMetadataBeanAllOf
     */
    'signroom'?: boolean;
    /**
     * Document Type for Strongdox
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'documentClass'?: string;
    /**
     * The id of contract for Volumen
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'contractId'?: string;
    /**
     * Financial plan id
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'planId'?: string;
    /**
     * Service Type Code
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'serviceTypeCode'?: string;
    /**
     * Report ID
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportMasterId'?: string;
    /**
     * Report Category
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportCategory'?: string;
    /**
     * Report type
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportType'?: string;
    /**
     * Module ID
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'moduleId'?: string;
    /**
     * Order list
     * @type {Array<OrderMetadataBean>}
     * @memberof DispositionMetadataBeanAllOf
     */
    'orders'?: Array<OrderMetadataBean>;
    /**
     * Total amount
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'totalAmount'?: string;
    /**
     * Total Amount Currency
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'totalAmountCurrency'?: string;
}
/**
 * 
 * @export
 * @interface DocumentBean
 */
export interface DocumentBean {
    /**
     * The id of the metadata object
     * @type {string}
     * @memberof DocumentBean
     */
    'id'?: string;
    /**
     * The mime type of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'mimeType'?: string;
    /**
     * The hash of the metadata object
     * @type {string}
     * @memberof DocumentBean
     */
    'hash'?: string;
    /**
     * The category of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'category'?: string;
    /**
     * The scope of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'scope'?: string;
    /**
     * The origin of the document, used to define internal flows, grant univocity with bundleId
     * @type {string}
     * @memberof DocumentBean
     */
    'origin'?: string;
    /**
     * The source of the document, used to define external flows
     * @type {string}
     * @memberof DocumentBean
     */
    'source'?: string;
    /**
     * The name of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'documentName'?: string;
    /**
     * The type of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'documentType'?: string;
    /**
     * Size of the document in bytes
     * @type {number}
     * @memberof DocumentBean
     */
    'documentSize'?: number;
    /**
     * The foreign key to the document id on the dms
     * @type {string}
     * @memberof DocumentBean
     */
    'dmsId'?: string;
    /**
     * The document URL
     * @type {string}
     * @memberof DocumentBean
     */
    'documentURL'?: string;
    /**
     * The code of the owner of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'ownerCode'?: string;
    /**
     * The id of the bundle, with this info can group a different files
     * @type {string}
     * @memberof DocumentBean
     */
    'bundleId'?: string;
    /**
     * The status of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'status'?: string;
    /**
     * If the document has been read its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBean
     */
    'read'?: boolean;
    /**
     * The creation date of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'creationDate'?: string;
    /**
     * The accrual date of the document (competence date)
     * @type {string}
     * @memberof DocumentBean
     */
    'accrualDate'?: string;
    /**
     * The date of expiration, after this date de document is not find in search
     * @type {string}
     * @memberof DocumentBean
     */
    'expirationDate'?: string;
    /**
     * If the document has been downloaded its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBean
     */
    'downloaded'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentBean
     */
    'externalUrl'?: string;
    /**
     * Visibility groups of the document (PUBLIC, PRIVATE)
     * @type {Array<string>}
     * @memberof DocumentBean
     */
    'visibilityGroups'?: DocumentBeanVisibilityGroupsEnum;
    /**
     * Contacts to send notification email to
     * @type {Array<ContactInfoBean>}
     * @memberof DocumentBean
     */
    'contactInfoList'?: Array<ContactInfoBean>;
    /**
     * Additional metadata infos of the document
     * @type {{ [key: string]: string; }}
     * @memberof DocumentBean
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof DocumentBean
     */
    'complexMetadata'?: DocumentBeanComplexMetadataComplexMetadata;
}

export const DocumentBeanVisibilityGroupsEnum = {
    Public: 'PUBLIC',
    Private: 'PRIVATE'
} as const;

export type DocumentBeanVisibilityGroupsEnum = typeof DocumentBeanVisibilityGroupsEnum[keyof typeof DocumentBeanVisibilityGroupsEnum];

/**
 * 
 * @export
 * @interface DocumentBeanComplexMetadata
 */
export interface DocumentBeanComplexMetadata {
    /**
     * The id of the metadata object
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'id'?: string;
    /**
     * The mime type of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'mimeType'?: string;
    /**
     * The hash of the metadata object
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'hash'?: string;
    /**
     * The category of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'category'?: string;
    /**
     * The scope of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'scope'?: string;
    /**
     * The origin of the document, used to define internal flows, grant univocity with bundleId
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'origin'?: string;
    /**
     * The source of the document, used to define external flows
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'source'?: string;
    /**
     * The name of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentName'?: string;
    /**
     * The type of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentType'?: string;
    /**
     * Size of the document in bytes
     * @type {number}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentSize'?: number;
    /**
     * The foreign key to the document id on the dms
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'dmsId'?: string;
    /**
     * The document URL
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentURL'?: string;
    /**
     * The code of the owner of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'ownerCode'?: string;
    /**
     * The id of the bundle, with this info can group a different files
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'bundleId'?: string;
    /**
     * The status of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'status'?: string;
    /**
     * If the document has been read its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBeanComplexMetadata
     */
    'read'?: boolean;
    /**
     * The creation date of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'creationDate'?: string;
    /**
     * The accrual date of the document (competence date)
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'accrualDate'?: string;
    /**
     * The date of expiration, after this date de document is not find in search
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'expirationDate'?: string;
    /**
     * If the document has been downloaded its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBeanComplexMetadata
     */
    'downloaded'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'externalUrl'?: string;
    /**
     * Visibility groups of the document (PUBLIC, PRIVATE)
     * @type {Array<string>}
     * @memberof DocumentBeanComplexMetadata
     */
    'visibilityGroups'?: DocumentBeanComplexMetadataVisibilityGroupsEnum;
    /**
     * Contacts to send notification email to
     * @type {Array<ContactInfoBean>}
     * @memberof DocumentBeanComplexMetadata
     */
    'contactInfoList'?: Array<ContactInfoBean>;
    /**
     * Additional metadata infos of the document
     * @type {{ [key: string]: string; }}
     * @memberof DocumentBeanComplexMetadata
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof DocumentBeanComplexMetadata
     */
    'complexMetadata'?: DocumentBeanComplexMetadataComplexMetadata;
}

export const DocumentBeanComplexMetadataVisibilityGroupsEnum = {
    Public: 'PUBLIC',
    Private: 'PRIVATE'
} as const;

export type DocumentBeanComplexMetadataVisibilityGroupsEnum = typeof DocumentBeanComplexMetadataVisibilityGroupsEnum[keyof typeof DocumentBeanComplexMetadataVisibilityGroupsEnum];

/**
 * @type DocumentBeanComplexMetadataComplexMetadata
 * @export
 */
export type DocumentBeanComplexMetadataComplexMetadata = NewsMetadata | SimpleMetadata;

/**
 * 
 * @export
 * @interface DocumentDownloadGroupedRequest
 */
export interface DocumentDownloadGroupedRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof DocumentDownloadGroupedRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'status'?: Array<string>;
    /**
     * Filter raed or unread documents
     * @type {boolean}
     * @memberof DocumentDownloadGroupedRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents whiteout filter
     * @type {boolean}
     * @memberof DocumentDownloadGroupedRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'externalUrl'?: string;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof DocumentDownloadGroupedRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof DocumentDownloadGroupedRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof DocumentDownloadGroupedRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     * 
     * @type {TextSearchParamFilter}
     * @memberof DocumentDownloadGroupedRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * Grouping conditions for documents
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'groupByFields': Array<string>;
    /**
     * User id who requested documents download.
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface DocumentMetadataGroupedRequest
 */
export interface DocumentMetadataGroupedRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'status'?: Array<string>;
    /**
     * Filter raed or unread documents
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents whiteout filter
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'externalUrl'?: string;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataGroupedRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataGroupedRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof DocumentMetadataGroupedRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     * 
     * @type {TextSearchParamFilter}
     * @memberof DocumentMetadataGroupedRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * 
     * @type {Paginator}
     * @memberof DocumentMetadataGroupedRequest
     */
    'paginator': Paginator;
    /**
     * Grouping conditions for documents
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'groupByFields': Array<string>;
    /**
     * Sorting conditions for documents. The document list inside each grouping will be sorted using these fields
     * @type {Set<OrderByStrategy>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'orderByStrategies'?: Set<OrderByStrategy>;
    /**
     * Option to filter null value
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'filterNullValue'?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentMetadataRequest
 */
export interface DocumentMetadataRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof DocumentMetadataRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'status'?: Array<string>;
    /**
     * Filter raed or unread documents
     * @type {boolean}
     * @memberof DocumentMetadataRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents whiteout filter
     * @type {boolean}
     * @memberof DocumentMetadataRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'externalUrl'?: string;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     * 
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof DocumentMetadataRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     * 
     * @type {TextSearchParamFilter}
     * @memberof DocumentMetadataRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * 
     * @type {Paginator}
     * @memberof DocumentMetadataRequest
     */
    'paginator': Paginator;
}
/**
 * 
 * @export
 * @interface DocumentNestedGroup
 */
export interface DocumentNestedGroup {
    /**
     * 
     * @type {string}
     * @memberof DocumentNestedGroup
     */
    '@class': string;
}
/**
 * document search filter request
 * @export
 * @interface DocumentSearchFilterRequest
 */
export interface DocumentSearchFilterRequest {
    /**
     * activate filter on customer code
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'customerCode'?: string;
    /**
     * activate filter on customer nominative
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'customerNominative'?: string;
    /**
     * activate filter on agent code
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'agentCode'?: string;
    /**
     * activate filter on document types
     * @type {Array<string>}
     * @memberof DocumentSearchFilterRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * activate filter on document scopes
     * @type {Array<string>}
     * @memberof DocumentSearchFilterRequest
     */
    'scopes'?: Array<string>;
    /**
     * activate filter on bundle id
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'bundleId'?: string;
    /**
     * activate filter if document is read
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'read'?: boolean;
    /**
     * activate filter on publication date lesser limit
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'publicationDateFrom'?: string;
    /**
     * activate filter on publication date upper limit
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'publicationDateTo'?: string;
    /**
     * activate filter if document is expired
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'expired'?: boolean;
    /**
     * activate filter if document is near expiration date
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'nearExpire'?: boolean;
    /**
     * activate filter on document presents in signroom
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'signroom'?: boolean;
    /**
     * 
     * @type {Paginator}
     * @memberof DocumentSearchFilterRequest
     */
    'paginator'?: Paginator;
}
/**
 * Attribute information of the document type
 * @export
 * @interface DocumentTypeAttributeBean
 */
export interface DocumentTypeAttributeBean {
    /**
     * History mode attribute info, true if history mode enabled for document type
     * @type {boolean}
     * @memberof DocumentTypeAttributeBean
     */
    'history'?: boolean;
    /**
     * Notify mode attribute info, true if notifications are enabled for document type
     * @type {boolean}
     * @memberof DocumentTypeAttributeBean
     */
    'notify'?: boolean;
    /**
     * Template used for document type attribute info
     * @type {string}
     * @memberof DocumentTypeAttributeBean
     */
    'template'?: string;
}
/**
 * 
 * @export
 * @interface DocumentTypeInfoBean
 */
export interface DocumentTypeInfoBean {
    /**
     * Document type
     * @type {string}
     * @memberof DocumentTypeInfoBean
     */
    'documentType'?: string;
    /**
     * Document scope
     * @type {string}
     * @memberof DocumentTypeInfoBean
     */
    'documentScope'?: string;
    /**
     * Document category
     * @type {string}
     * @memberof DocumentTypeInfoBean
     */
    'documentCategory'?: string;
    /**
     * 
     * @type {DocumentTypeAttributeBean}
     * @memberof DocumentTypeInfoBean
     */
    'attributes'?: DocumentTypeAttributeBean;
    /**
     * Additional information extension value list of the document type
     * @type {Array<string>}
     * @memberof DocumentTypeInfoBean
     */
    'extensionValues'?: Array<string>;
}
/**
 * Document User List
 * @export
 * @interface DocumentUser
 */
export interface DocumentUser {
    /**
     * User code
     * @type {string}
     * @memberof DocumentUser
     */
    'code': string;
    /**
     * User role, C=Customer  A=Agent)
     * @type {string}
     * @memberof DocumentUser
     */
    'role': DocumentUserRoleEnum;
    /**
     * User full name
     * @type {string}
     * @memberof DocumentUser
     */
    'name': string;
    /**
     * Hide document user
     * @type {boolean}
     * @memberof DocumentUser
     */
    'docHidden': boolean;
    /**
     * True if user must sign
     * @type {boolean}
     * @memberof DocumentUser
     */
    'signer': boolean;
    /**
     * User BehalOf Code
     * @type {string}
     * @memberof DocumentUser
     */
    'userBehalfOfCode'?: string;
    /**
     * User BehalOf Type, C=Customer A=Agent
     * @type {string}
     * @memberof DocumentUser
     */
    'userBehalfOfType'?: DocumentUserUserBehalfOfTypeEnum;
}

export const DocumentUserRoleEnum = {
    C: 'C',
    A: 'A'
} as const;

export type DocumentUserRoleEnum = typeof DocumentUserRoleEnum[keyof typeof DocumentUserRoleEnum];
export const DocumentUserUserBehalfOfTypeEnum = {
    C: 'C',
    A: 'A'
} as const;

export type DocumentUserUserBehalfOfTypeEnum = typeof DocumentUserUserBehalfOfTypeEnum[keyof typeof DocumentUserUserBehalfOfTypeEnum];

/**
 * 
 * @export
 * @interface DownloadBundleRequest
 */
export interface DownloadBundleRequest {
    /**
     * The bundle ids of the documents to download
     * @type {Set<string>}
     * @memberof DownloadBundleRequest
     */
    'bundleIds'?: Set<string>;
    /**
     * User id who requested documents download. Optional attribute.
     * @type {string}
     * @memberof DownloadBundleRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface DownloadHistoryBean
 */
export interface DownloadHistoryBean {
    /**
     * The document id of the download history entry object
     * @type {string}
     * @memberof DownloadHistoryBean
     */
    'documentId'?: string;
    /**
     * The user id of the download history entry object
     * @type {string}
     * @memberof DownloadHistoryBean
     */
    'userId'?: string;
    /**
     * The download date of the download history entry object
     * @type {string}
     * @memberof DownloadHistoryBean
     */
    'downloadDate'?: string;
    /**
     * The document size of the download history entry object
     * @type {number}
     * @memberof DownloadHistoryBean
     */
    'documentSize'?: number;
}
/**
 * 
 * @export
 * @interface DownloadHistoryRequest
 */
export interface DownloadHistoryRequest {
    /**
     * Filter by id of the document downloaded
     * @type {Set<string>}
     * @memberof DownloadHistoryRequest
     */
    'documentIds'?: Set<string>;
    /**
     * Filter by user id who downloaded document
     * @type {Set<string>}
     * @memberof DownloadHistoryRequest
     */
    'userIds'?: Set<string>;
    /**
     * Filter by document download date. Start date value filter.
     * @type {string}
     * @memberof DownloadHistoryRequest
     */
    'startDownloadDate'?: string;
    /**
     * Filter by document download date. End date value filter.
     * @type {string}
     * @memberof DownloadHistoryRequest
     */
    'endDownloadDate'?: string;
    /**
     * Filter by size of the document downloaded. Min size value filter.
     * @type {number}
     * @memberof DownloadHistoryRequest
     */
    'minDocumentSize'?: number;
    /**
     * Filter by size of the document downloaded. Max size value filter.
     * @type {number}
     * @memberof DownloadHistoryRequest
     */
    'maxDocumentSize'?: number;
    /**
     * If true items with null or not null userId are added, also if userId is null or not set
     * @type {boolean}
     * @memberof DownloadHistoryRequest
     */
    'nullOrNotNullUserIdEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface DownloadHistoryStatisticBean
 */
export interface DownloadHistoryStatisticBean {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DownloadHistoryStatisticBean
     */
    'groupedFieldMap'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof DownloadHistoryStatisticBean
     */
    'downloadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadHistoryStatisticBean
     */
    'downloadTotalSize'?: number;
}
/**
 * 
 * @export
 * @interface DownloadHistoryStatisticsRequest
 */
export interface DownloadHistoryStatisticsRequest {
    /**
     * 
     * @type {Paginator}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'paginator'?: Paginator;
    /**
     * 
     * @type {Set<string>}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'groupFieldSet'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'groupDateType'?: DownloadHistoryStatisticsRequestGroupDateTypeEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'documentIds'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'userIds'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'startDownloadDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'endDownloadDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'minDocumentSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'maxDocumentSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'minCumulativeDocumentSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'maxCumulativeDocumentSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'nullOrNotNullUserIdEnabled'?: boolean;
}

export const DownloadHistoryStatisticsRequestGroupDateTypeEnum = {
    Year: 'YEAR',
    Month: 'MONTH',
    Day: 'DAY',
    Hour: 'HOUR',
    Minute: 'MINUTE'
} as const;

export type DownloadHistoryStatisticsRequestGroupDateTypeEnum = typeof DownloadHistoryStatisticsRequestGroupDateTypeEnum[keyof typeof DownloadHistoryStatisticsRequestGroupDateTypeEnum];

/**
 * 
 * @export
 * @interface DownloadMultiRequest
 */
export interface DownloadMultiRequest {
    /**
     * The id of the documents to download
     * @type {Set<string>}
     * @memberof DownloadMultiRequest
     */
    'ids'?: Set<string>;
    /**
     * User id who requested documents download. Optional attribute.
     * @type {string}
     * @memberof DownloadMultiRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface FeqMetadata
 */
export interface FeqMetadata extends SimpleMetadata {
    /**
     * documentData from signroom
     * @type {boolean}
     * @memberof FeqMetadata
     */
    'signroom': boolean;
    /**
     * Document Type for Strongdox
     * @type {string}
     * @memberof FeqMetadata
     */
    'documentClass'?: string;
    /**
     * The id of contract for Volumen
     * @type {string}
     * @memberof FeqMetadata
     */
    'contractId'?: string;
}
/**
 * 
 * @export
 * @interface FeqMetadataAllOf
 */
export interface FeqMetadataAllOf {
    /**
     * documentData from signroom
     * @type {boolean}
     * @memberof FeqMetadataAllOf
     */
    'signroom'?: boolean;
    /**
     * Document Type for Strongdox
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'documentClass'?: string;
    /**
     * The id of contract for Volumen
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'contractId'?: string;
}
/**
 * HandbookBean (ComplexMetadata)
 * @export
 * @interface HandbookMetadataBean
 */
export interface HandbookMetadataBean extends ComplexMetadata {
}
/**
 * 
 * @export
 * @interface InfoServiceBean
 */
export interface InfoServiceBean {
    /**
     * 
     * @type {string}
     * @memberof InfoServiceBean
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoServiceBean
     */
    'version'?: string;
}
/**
 * InformationOfferBean (ComplexMetadata)
 * @export
 * @interface InformationOfferMetadataBean
 */
export interface InformationOfferMetadataBean extends SimpleMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof InformationOfferMetadataBean
     */
    'practiceType'?: string;
    /**
     * the company of the information offer
     * @type {string}
     * @memberof InformationOfferMetadataBean
     */
    'company'?: string;
}
/**
 * 
 * @export
 * @interface InformationOfferMetadataBeanAllOf
 */
export interface InformationOfferMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * the company of the information offer
     * @type {string}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'company'?: string;
}
/**
 * 
 * @export
 * @interface MultipartBody
 */
export interface MultipartBody {
    /**
     * 
     * @type {AttachmentContentType}
     * @memberof MultipartBody
     */
    'type'?: AttachmentContentType;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof MultipartBody
     */
    'allAttachments'?: Array<Attachment>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof MultipartBody
     */
    'childAttachments'?: Array<Attachment>;
    /**
     * 
     * @type {Attachment}
     * @memberof MultipartBody
     */
    'rootAttachment'?: Attachment;
}
/**
 * 
 * @export
 * @interface NewsMetadata
 */
export interface NewsMetadata extends ComplexMetadata {
    /**
     * Title of news
     * @type {string}
     * @memberof NewsMetadata
     */
    'title'?: string;
    /**
     * Description of news
     * @type {string}
     * @memberof NewsMetadata
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsMetadata
     */
    '@class': string;
}
/**
 * 
 * @export
 * @interface NewsMetadataAllOf
 */
export interface NewsMetadataAllOf {
    /**
     * Title of news
     * @type {string}
     * @memberof NewsMetadataAllOf
     */
    'title'?: string;
    /**
     * Description of news
     * @type {string}
     * @memberof NewsMetadataAllOf
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsMetadataAllOf
     */
    '@class'?: string;
}
/**
 * Sorting conditions for documents. The document list inside each grouping will be sorted using these fields
 * @export
 * @interface OrderByStrategy
 */
export interface OrderByStrategy {
    /**
     * the name of the field to sort internal group collection
     * @type {string}
     * @memberof OrderByStrategy
     */
    'orderField': string;
    /**
     * order type of the sort. Default is ASC
     * @type {string}
     * @memberof OrderByStrategy
     */
    'orderType'?: OrderByStrategyOrderTypeEnum;
}

export const OrderByStrategyOrderTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type OrderByStrategyOrderTypeEnum = typeof OrderByStrategyOrderTypeEnum[keyof typeof OrderByStrategyOrderTypeEnum];

/**
 * Order used for RTO flow
 * @export
 * @interface OrderMetadataBean
 */
export interface OrderMetadataBean {
    /**
     * Order id
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'id': string;
    /**
     * Order amount
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'amount': string;
    /**
     * Order currency
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'currency'?: string;
    /**
     * Order mandate
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'mandate'?: string;
    /**
     * Order operation
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'operation'?: string;
    /**
     * Order operation description
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'operationDesc'?: string;
    /**
     * Payment Type
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'paymentType'?: string;
    /**
     * Macro product code
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'macroProduct'?: string;
    /**
     * Product company code
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productCompany'?: string;
    /**
     * Product name
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productName': string;
    /**
     * Product code
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productCode': string;
    /**
     * Product ISIN
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productIsin'?: string;
    /**
     * Amount ISO
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'amountIso'?: string;
    /**
     * Product company description
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productCompanyDesc'?: string;
    /**
     * Product type
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productType': string;
    /**
     * Quantity
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'quantity': string;
    /**
     * Order not appropiate
     * @type {boolean}
     * @memberof OrderMetadataBean
     */
    'notAppropriate'?: OrderMetadataBeanNotAppropriateEnum;
    /**
     * kid exists
     * @type {boolean}
     * @memberof OrderMetadataBean
     */
    'existsKidDoc'?: OrderMetadataBeanExistsKidDocEnum;
}

export const OrderMetadataBeanNotAppropriateEnum = {
    False: false
} as const;

export type OrderMetadataBeanNotAppropriateEnum = typeof OrderMetadataBeanNotAppropriateEnum[keyof typeof OrderMetadataBeanNotAppropriateEnum];
export const OrderMetadataBeanExistsKidDocEnum = {
    False: false,
    True: true
} as const;

export type OrderMetadataBeanExistsKidDocEnum = typeof OrderMetadataBeanExistsKidDocEnum[keyof typeof OrderMetadataBeanExistsKidDocEnum];

/**
 * Paginator info
 * @export
 * @interface Paginator
 */
export interface Paginator {
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'totalPageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'current'?: number;
    /**
     * 
     * @type {string}
     * @memberof Paginator
     */
    'orderType'?: PaginatorOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Paginator
     */
    'orderBy'?: string;
}

export const PaginatorOrderTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type PaginatorOrderTypeEnum = typeof PaginatorOrderTypeEnum[keyof typeof PaginatorOrderTypeEnum];

/**
 * 
 * @export
 * @interface PermissionServiceBean
 */
export interface PermissionServiceBean {
    /**
     * 
     * @type {string}
     * @memberof PermissionServiceBean
     */
    'name'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PermissionServiceBean
     */
    'permissions'?: Set<string>;
}
/**
 * 
 * @export
 * @interface ReadDocumentRequest
 */
export interface ReadDocumentRequest {
    /**
     * 
     * @type {Set<string>}
     * @memberof ReadDocumentRequest
     */
    'documentId': Set<string>;
    /**
     * 
     * @type {string}
     * @memberof ReadDocumentRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ReadDocumentRequest
     */
    'readTime'?: string;
}
/**
 * ReportBean (ComplexMetadata)
 * @export
 * @interface ReportMetadataBean
 */
export interface ReportMetadataBean extends SimpleMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ReportMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ReportMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ReportMetadataBean
     */
    'practiceType'?: string;
}
/**
 * 
 * @export
 * @interface ResponseCommunicationMetadataBean
 */
export interface ResponseCommunicationMetadataBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseCommunicationMetadataBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCommunicationMetadataBean
     */
    'message'?: string;
    /**
     * 
     * @type {CommunicationMetadataBean}
     * @memberof ResponseCommunicationMetadataBean
     */
    'result'?: CommunicationMetadataBean;
}
/**
 * 
 * @export
 * @interface ResponseContractMetadataBean
 */
export interface ResponseContractMetadataBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseContractMetadataBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseContractMetadataBean
     */
    'message'?: string;
    /**
     * 
     * @type {ContractMetadataBean}
     * @memberof ResponseContractMetadataBean
     */
    'result'?: ContractMetadataBean;
}
/**
 * 
 * @export
 * @interface ResponseDispositionMetadataBean
 */
export interface ResponseDispositionMetadataBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseDispositionMetadataBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseDispositionMetadataBean
     */
    'message'?: string;
    /**
     * 
     * @type {DispositionMetadataBean}
     * @memberof ResponseDispositionMetadataBean
     */
    'result'?: DispositionMetadataBean;
}
/**
 * 
 * @export
 * @interface ResponseDocumentBeanComplexMetadata
 */
export interface ResponseDocumentBeanComplexMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponseDocumentBeanComplexMetadata
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseDocumentBeanComplexMetadata
     */
    'message'?: string;
    /**
     * 
     * @type {DocumentBeanComplexMetadata}
     * @memberof ResponseDocumentBeanComplexMetadata
     */
    'result'?: DocumentBeanComplexMetadata;
}
/**
 * 
 * @export
 * @interface ResponseFeqMetadata
 */
export interface ResponseFeqMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponseFeqMetadata
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseFeqMetadata
     */
    'message'?: string;
    /**
     * 
     * @type {FeqMetadata}
     * @memberof ResponseFeqMetadata
     */
    'result'?: FeqMetadata;
}
/**
 * 
 * @export
 * @interface ResponseHandbookMetadataBean
 */
export interface ResponseHandbookMetadataBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseHandbookMetadataBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseHandbookMetadataBean
     */
    'message'?: string;
    /**
     * 
     * @type {HandbookMetadataBean}
     * @memberof ResponseHandbookMetadataBean
     */
    'result'?: HandbookMetadataBean;
}
/**
 * 
 * @export
 * @interface ResponseInfoServiceBean
 */
export interface ResponseInfoServiceBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'message'?: string;
    /**
     * 
     * @type {InfoServiceBean}
     * @memberof ResponseInfoServiceBean
     */
    'result'?: InfoServiceBean;
}
/**
 * 
 * @export
 * @interface ResponseInformationOfferMetadataBean
 */
export interface ResponseInformationOfferMetadataBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseInformationOfferMetadataBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseInformationOfferMetadataBean
     */
    'message'?: string;
    /**
     * 
     * @type {InformationOfferMetadataBean}
     * @memberof ResponseInformationOfferMetadataBean
     */
    'result'?: InformationOfferMetadataBean;
}
/**
 * 
 * @export
 * @interface ResponseListDocumentBeanComplexMetadata
 */
export interface ResponseListDocumentBeanComplexMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponseListDocumentBeanComplexMetadata
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListDocumentBeanComplexMetadata
     */
    'message'?: string;
    /**
     * 
     * @type {Array<DocumentBeanComplexMetadata>}
     * @memberof ResponseListDocumentBeanComplexMetadata
     */
    'result'?: Array<DocumentBeanComplexMetadata>;
}
/**
 * 
 * @export
 * @interface ResponseListDocumentTypeInfoBean
 */
export interface ResponseListDocumentTypeInfoBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseListDocumentTypeInfoBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListDocumentTypeInfoBean
     */
    'message'?: string;
    /**
     * 
     * @type {Array<DocumentTypeInfoBean>}
     * @memberof ResponseListDocumentTypeInfoBean
     */
    'result'?: Array<DocumentTypeInfoBean>;
}
/**
 * 
 * @export
 * @interface ResponseLong
 */
export interface ResponseLong {
    /**
     * 
     * @type {string}
     * @memberof ResponseLong
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseLong
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseLong
     */
    'result'?: number;
}
/**
 * 
 * @export
 * @interface ResponseMapStringString
 */
export interface ResponseMapStringString {
    /**
     * 
     * @type {string}
     * @memberof ResponseMapStringString
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseMapStringString
     */
    'message'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ResponseMapStringString
     */
    'result'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ResponseNewsMetadata
 */
export interface ResponseNewsMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponseNewsMetadata
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseNewsMetadata
     */
    'message'?: string;
    /**
     * 
     * @type {NewsMetadata}
     * @memberof ResponseNewsMetadata
     */
    'result'?: NewsMetadata;
}
/**
 * 
 * @export
 * @interface ResponsePaginatedCollectionDownloadHistoryBean
 */
export interface ResponsePaginatedCollectionDownloadHistoryBean {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'message'?: string;
    /**
     * 
     * @type {Array<DownloadHistoryBean>}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'result'?: Array<DownloadHistoryBean>;
    /**
     * 
     * @type {Paginator}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @interface ResponsePaginatedCollectionDownloadHistoryStatisticBean
 */
export interface ResponsePaginatedCollectionDownloadHistoryStatisticBean {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'message'?: string;
    /**
     * 
     * @type {Array<DownloadHistoryStatisticBean>}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'result'?: Array<DownloadHistoryStatisticBean>;
    /**
     * 
     * @type {Paginator}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @interface ResponsePaginatedListDocumentBeanComplexMetadata
 */
export interface ResponsePaginatedListDocumentBeanComplexMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'message'?: string;
    /**
     * 
     * @type {Array<DocumentBeanComplexMetadata>}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'result'?: Array<DocumentBeanComplexMetadata>;
    /**
     * 
     * @type {Paginator}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @interface ResponsePaginatedMapStringDocumentNestedGroup
 */
export interface ResponsePaginatedMapStringDocumentNestedGroup {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'message'?: string;
    /**
     * 
     * @type {{ [key: string]: DocumentNestedGroup; }}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'result'?: { [key: string]: DocumentNestedGroup; };
    /**
     * 
     * @type {Paginator}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @interface ResponsePermissionServiceBean
 */
export interface ResponsePermissionServiceBean {
    /**
     * 
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'message'?: string;
    /**
     * 
     * @type {PermissionServiceBean}
     * @memberof ResponsePermissionServiceBean
     */
    'result'?: PermissionServiceBean;
}
/**
 * 
 * @export
 * @interface ResponseReportMetadataBean
 */
export interface ResponseReportMetadataBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseReportMetadataBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportMetadataBean
     */
    'message'?: string;
    /**
     * 
     * @type {ReportMetadataBean}
     * @memberof ResponseReportMetadataBean
     */
    'result'?: ReportMetadataBean;
}
/**
 * 
 * @export
 * @interface ResponseSaveDocumentResponse
 */
export interface ResponseSaveDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponseSaveDocumentResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseSaveDocumentResponse
     */
    'message'?: string;
    /**
     * 
     * @type {SaveDocumentResponse}
     * @memberof ResponseSaveDocumentResponse
     */
    'result'?: SaveDocumentResponse;
}
/**
 * 
 * @export
 * @interface ResponseSetClass
 */
export interface ResponseSetClass {
    /**
     * 
     * @type {string}
     * @memberof ResponseSetClass
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseSetClass
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ResponseString
 */
export interface ResponseString {
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    'result'?: string;
}
/**
 * 
 * @export
 * @interface ResponseVoid
 */
export interface ResponseVoid {
    /**
     * 
     * @type {string}
     * @memberof ResponseVoid
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseVoid
     */
    'message'?: string;
    /**
     * 
     * @type {object}
     * @memberof ResponseVoid
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface SaveDocumentResponse
 */
export interface SaveDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof SaveDocumentResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveDocumentResponse
     */
    'dmsId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveDocumentResponse
     */
    'dmsUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDocumentResponse
     */
    'sendNotification'?: boolean;
}
/**
 * 
 * @export
 * @interface SaveDownloadHistoryRequest
 */
export interface SaveDownloadHistoryRequest {
    /**
     * The id of the document downloaded
     * @type {string}
     * @memberof SaveDownloadHistoryRequest
     */
    'documentId': string;
    /**
     * User id who downloaded document. Optional attribute.
     * @type {string}
     * @memberof SaveDownloadHistoryRequest
     */
    'userId'?: string;
    /**
     * The date-time of download event. Optional attribute. If omitted is used now date-time as default value
     * @type {string}
     * @memberof SaveDownloadHistoryRequest
     */
    'downloadDate'?: string;
    /**
     * The size of the document downloaded. Optional attribute
     * @type {number}
     * @memberof SaveDownloadHistoryRequest
     */
    'documentSize'?: number;
}
/**
 * 
 * @export
 * @interface SearchDownloadHistoryRequest
 */
export interface SearchDownloadHistoryRequest {
    /**
     * Filter by id of the document downloaded
     * @type {Set<string>}
     * @memberof SearchDownloadHistoryRequest
     */
    'documentIds'?: Set<string>;
    /**
     * Filter by user id who downloaded document
     * @type {Set<string>}
     * @memberof SearchDownloadHistoryRequest
     */
    'userIds'?: Set<string>;
    /**
     * Filter by document download date. Start date value filter.
     * @type {string}
     * @memberof SearchDownloadHistoryRequest
     */
    'startDownloadDate'?: string;
    /**
     * Filter by document download date. End date value filter.
     * @type {string}
     * @memberof SearchDownloadHistoryRequest
     */
    'endDownloadDate'?: string;
    /**
     * Filter by size of the document downloaded. Min size value filter.
     * @type {number}
     * @memberof SearchDownloadHistoryRequest
     */
    'minDocumentSize'?: number;
    /**
     * Filter by size of the document downloaded. Max size value filter.
     * @type {number}
     * @memberof SearchDownloadHistoryRequest
     */
    'maxDocumentSize'?: number;
    /**
     * If true items with null or not null userId are added, also if userId is null or not set
     * @type {boolean}
     * @memberof SearchDownloadHistoryRequest
     */
    'nullOrNotNullUserIdEnabled'?: boolean;
    /**
     * 
     * @type {Paginator}
     * @memberof SearchDownloadHistoryRequest
     */
    'paginator': Paginator;
}
/**
 * 
 * @export
 * @interface SimpleMetadata
 */
export interface SimpleMetadata extends ComplexMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadata
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadata
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof SimpleMetadata
     */
    'practiceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleMetadata
     */
    '@class': string;
}
/**
 * 
 * @export
 * @interface SimpleMetadataAllOf
 */
export interface SimpleMetadataAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadataAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadataAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof SimpleMetadataAllOf
     */
    'practiceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleMetadataAllOf
     */
    '@class'?: string;
}
/**
 * Search by text in document metadata
 * @export
 * @interface TextSearchParamFilter
 */
export interface TextSearchParamFilter {
    /**
     * The operator to be applied on the field
     * @type {string}
     * @memberof TextSearchParamFilter
     */
    'operator': TextSearchParamFilterOperatorEnum;
    /**
     * The value to be parsed by the operator
     * @type {Array<string>}
     * @memberof TextSearchParamFilter
     */
    'value': Array<string>;
    /**
     * To exclude a word in text search
     * @type {boolean}
     * @memberof TextSearchParamFilter
     */
    'exclusion'?: boolean;
    /**
     * To set the language of text
     * @type {string}
     * @memberof TextSearchParamFilter
     */
    'language'?: string;
    /**
     * To set if search is diacriticSensitive
     * @type {boolean}
     * @memberof TextSearchParamFilter
     */
    'diacriticSensitive'?: boolean;
    /**
     * To set if search is caseSensitive
     * @type {boolean}
     * @memberof TextSearchParamFilter
     */
    'caseSensitive'?: boolean;
}

export const TextSearchParamFilterOperatorEnum = {
    Word: 'WORD',
    Any: 'ANY',
    Phrase: 'PHRASE'
} as const;

export type TextSearchParamFilterOperatorEnum = typeof TextSearchParamFilterOperatorEnum[keyof typeof TextSearchParamFilterOperatorEnum];

/**
 * 
 * @export
 * @interface UpdateComplexMetadataRequestComplexMetadata
 */
export interface UpdateComplexMetadataRequestComplexMetadata {
    /**
     * 
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof UpdateComplexMetadataRequestComplexMetadata
     */
    'The new complex metadata to be saved'?: DocumentBeanComplexMetadataComplexMetadata;
}
/**
 * 
 * @export
 * @interface UpdateDocumentRequest
 */
export interface UpdateDocumentRequest {
    /**
     * The new ownerCode to be saved
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    'ownerCode'?: string;
    /**
     * The new status to be saved
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    'status'?: string;
    /**
     * The new expirationDate to be saved
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    'expirationDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMetadataRequest
 */
export interface UpdateMetadataRequest {
    /**
     * The new metadata to be saved
     * @type {{ [key: string]: string; }}
     * @memberof UpdateMetadataRequest
     */
    'metadata'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface UploadRequestSwaggerDescriptor
 */
export interface UploadRequestSwaggerDescriptor {
    /**
     * file to upload
     * @type {File}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'content': File;
    /**
     * owner of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'ownerCode'?: string;
    /**
     * type of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'document-type': string;
    /**
     * upload origin
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'origin': string;
    /**
     * source system name
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'source'?: string;
    /**
     * name of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'filename': string;
    /**
     * status of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'status'?: string;
    /**
     * mime-type of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'mime-type'?: UploadRequestSwaggerDescriptorMimeTypeEnum;
    /**
     * content length of the file to upload
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'size'?: UploadRequestSwaggerDescriptorSizeEnum;
    /**
     * 
     * @type {SimpleMetadata}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'complexMetadata': SimpleMetadata;
    /**
     * contact data to notify information list<string>
     * @type {Array<string>}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'contactInfoList'?: Array<string>;
    /**
     * metadata info in format map<string,string>, field subtype: \'application/json\'
     * @type {{ [key: string]: string; }}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'metadata'?: { [key: string]: string; };
    /**
     * document expiration date (dd/MM/yyyy)
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'expirationDate'?: string;
}

export const UploadRequestSwaggerDescriptorMimeTypeEnum = {
    ApplicationPdf: 'application/pdf'
} as const;

export type UploadRequestSwaggerDescriptorMimeTypeEnum = typeof UploadRequestSwaggerDescriptorMimeTypeEnum[keyof typeof UploadRequestSwaggerDescriptorMimeTypeEnum];
export const UploadRequestSwaggerDescriptorSizeEnum = {
    _0: '0'
} as const;

export type UploadRequestSwaggerDescriptorSizeEnum = typeof UploadRequestSwaggerDescriptorSizeEnum[keyof typeof UploadRequestSwaggerDescriptorSizeEnum];

/**
 * 
 * @export
 * @interface UploadRequestWithExternalRefSwaggerDescriptor
 */
export interface UploadRequestWithExternalRefSwaggerDescriptor {
    /**
     * file to upload
     * @type {File}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'content': File;
    /**
     * owner of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'ownerCode'?: string;
    /**
     * type of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'document-type': string;
    /**
     * upload origin
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'origin': string;
    /**
     * source system name
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'source'?: string;
    /**
     * name of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'filename': string;
    /**
     * status of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'status'?: string;
    /**
     * mime-type of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'mime-type'?: UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum;
    /**
     * content length of the file to upload
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'size'?: UploadRequestWithExternalRefSwaggerDescriptorSizeEnum;
    /**
     * 
     * @type {SimpleMetadata}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'complexMetadata': SimpleMetadata;
    /**
     * contact data to notify information list<string>
     * @type {Array<string>}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'contactInfoList'?: Array<string>;
    /**
     * metadata info in format map<string,string>, field subtype: \'application/json\'
     * @type {{ [key: string]: string; }}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'metadata'?: { [key: string]: string; };
    /**
     * True or false value is expected. If it is true enabled check if document already existing and retrieve previous document if it exists. External reference expected in origin attribute value 
     * @type {boolean}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'retrieveIfAlreadyExistingByExtRef'?: boolean;
    /**
     * If id is not empty will and if document already existing, then previous document will be deleted and document will be re-uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'documentIdToRecreate'?: string;
}

export const UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum = {
    ApplicationPdf: 'application/pdf'
} as const;

export type UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum = typeof UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum[keyof typeof UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum];
export const UploadRequestWithExternalRefSwaggerDescriptorSizeEnum = {
    _0: '0'
} as const;

export type UploadRequestWithExternalRefSwaggerDescriptorSizeEnum = typeof UploadRequestWithExternalRefSwaggerDescriptorSizeEnum[keyof typeof UploadRequestWithExternalRefSwaggerDescriptorSizeEnum];


/**
 * ComplexMetadataProviderApi - axios parameter creator
 * @export
 */
export const ComplexMetadataProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contractMetadataBean1', 'id', id)
            const localVarPath = `/document/stream/complex-metadata/contractMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary load complex metadata infos of NewsMetadata type
         * @param {string} id load complex metadata News
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsMetadata1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('newsMetadata1', 'id', id)
            const localVarPath = `/document/stream/complex-metadata/newsMetadata/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplexMetadataProviderApi - functional programming interface
 * @export
 */
export const ComplexMetadataProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComplexMetadataProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseContractMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary load complex metadata infos of NewsMetadata type
         * @param {string} id load complex metadata News
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newsMetadata1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseNewsMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newsMetadata1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComplexMetadataProviderApi - factory interface
 * @export
 */
export const ComplexMetadataProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComplexMetadataProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractMetadataBean1(id: string, options?: any): AxiosPromise<ResponseContractMetadataBean> {
            return localVarFp.contractMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary load complex metadata infos of NewsMetadata type
         * @param {string} id load complex metadata News
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsMetadata1(id: string, options?: any): AxiosPromise<ResponseNewsMetadata> {
            return localVarFp.newsMetadata1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for contractMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiContractMetadataBean1Request
 */
export interface ComplexMetadataProviderApiContractMetadataBean1Request {
    /**
     * load complex metadata Feq
     * @type {string}
     * @memberof ComplexMetadataProviderApiContractMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for newsMetadata1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiNewsMetadata1Request
 */
export interface ComplexMetadataProviderApiNewsMetadata1Request {
    /**
     * load complex metadata News
     * @type {string}
     * @memberof ComplexMetadataProviderApiNewsMetadata1
     */
    readonly id: string
}

/**
 * ComplexMetadataProviderApi - object-oriented interface
 * @export
 * @class ComplexMetadataProviderApi
 * @extends {BaseAPI}
 */
export class ComplexMetadataProviderApi extends BaseAPI {
    /**
     * 
     * @summary load complex metadata infos of Metadata type, used for digital sign flows
     * @param {ComplexMetadataProviderApiContractMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public contractMetadataBean1(requestParameters: ComplexMetadataProviderApiContractMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).contractMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary load complex metadata infos of NewsMetadata type
     * @param {ComplexMetadataProviderApiNewsMetadata1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public newsMetadata1(requestParameters: ComplexMetadataProviderApiNewsMetadata1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).newsMetadata1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentContentProviderApi - axios parameter creator
 * @export
 */
export const DocumentContentProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Downloads a document content by document id
         * @param {string} id The id of the document to download
         * @param {boolean} behalf Flag indicating if the user is PG.
         * @param {string} [userId] User id who requested the document download. Optional attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument2: async (id: string, behalf: boolean, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadDocument2', 'id', id)
            // verify required parameter 'behalf' is not null or undefined
            assertParamExists('downloadDocument2', 'behalf', behalf)
            const localVarPath = `/document/stream/documentContent/downloadDocument/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (behalf !== undefined) {
                localVarQueryParameter['behalf'] = behalf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads a zip group of documents, content is organized by folder specified by request group policy
         * @param {DocumentDownloadGroupedRequest} [documentDownloadGroupedRequest] Metadata group and search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentsByGroup2: async (documentDownloadGroupedRequest?: DocumentDownloadGroupedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/stream/documentContent/downloads/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentDownloadGroupedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the content of a document
         * @param {boolean} [replaceMetadata] Replace document and metadata flag. True if the new complex metadata and document will replace the existing, otherwise false
         * @param {AttachmentContentType} [type] 
         * @param {Array<Attachment>} [allAttachments] 
         * @param {Array<Attachment>} [childAttachments] 
         * @param {Attachment} [rootAttachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument2: async (replaceMetadata?: boolean, type?: AttachmentContentType, allAttachments?: Array<Attachment>, childAttachments?: Array<Attachment>, rootAttachment?: Attachment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/stream/documentContent/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (replaceMetadata !== undefined) {
                localVarQueryParameter['replaceMetadata'] = replaceMetadata;
            }


            if (type !== undefined) { 
                localVarFormParams.append('type', new Blob([JSON.stringify(type)], { type: "application/json", }));
            }
                if (allAttachments) {
                localVarFormParams.append('allAttachments', allAttachments.join(COLLECTION_FORMATS.csv));
            }

                if (childAttachments) {
                localVarFormParams.append('childAttachments', childAttachments.join(COLLECTION_FORMATS.csv));
            }

    
            if (rootAttachment !== undefined) { 
                localVarFormParams.append('rootAttachment', new Blob([JSON.stringify(rootAttachment)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads the content of a document
         * @param {File} content file to upload
         * @param {string} documentType type of the document uploaded
         * @param {string} origin upload origin
         * @param {string} filename name of the document uploaded
         * @param {SimpleMetadata} complexMetadata 
         * @param {string} [ownerCode] owner of the document uploaded
         * @param {string} [source] source system name
         * @param {string} [status] status of the document uploaded
         * @param {string} [mimeType] mime-type of the document uploaded
         * @param {string} [size] content length of the file to upload
         * @param {Array<string>} [contactInfoList] contact data to notify information list&lt;string&gt;
         * @param {string} [expirationDate] document expiration date (dd/MM/yyyy)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument2: async (content: File, documentType: string, origin: string, filename: string, complexMetadata: SimpleMetadata, ownerCode?: string, source?: string, status?: string, mimeType?: string, size?: string, contactInfoList?: Array<string>, expirationDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'content' is not null or undefined
            assertParamExists('uploadDocument2', 'content', content)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadDocument2', 'documentType', documentType)
            // verify required parameter 'origin' is not null or undefined
            assertParamExists('uploadDocument2', 'origin', origin)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('uploadDocument2', 'filename', filename)
            // verify required parameter 'complexMetadata' is not null or undefined
            assertParamExists('uploadDocument2', 'complexMetadata', complexMetadata)
            const localVarPath = `/document/stream/documentContent/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (ownerCode !== undefined) { 
                localVarFormParams.append('ownerCode', ownerCode as any);
            }
    
            if (documentType !== undefined) { 
                localVarFormParams.append('document-type', documentType as any);
            }
    
            if (origin !== undefined) { 
                localVarFormParams.append('origin', origin as any);
            }
    
            if (source !== undefined) { 
                localVarFormParams.append('source', source as any);
            }
    
            if (filename !== undefined) { 
                localVarFormParams.append('filename', filename as any);
            }
    
            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }
    
            if (mimeType !== undefined) { 
                localVarFormParams.append('mime-type', mimeType as any);
            }
    
            if (size !== undefined) { 
                localVarFormParams.append('size', size as any);
            }
    
            if (complexMetadata !== undefined) { 
                localVarFormParams.append('complexMetadata', new Blob([JSON.stringify(complexMetadata)], { type: "application/json", }));
            }
                if (contactInfoList) {
                localVarFormParams.append('contactInfoList', contactInfoList.join(COLLECTION_FORMATS.csv));
            }

    
            if (expirationDate !== undefined) { 
                localVarFormParams.append('expirationDate', expirationDate as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentContentProviderApi - functional programming interface
 * @export
 */
export const DocumentContentProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentContentProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Downloads a document content by document id
         * @param {string} id The id of the document to download
         * @param {boolean} behalf Flag indicating if the user is PG.
         * @param {string} [userId] User id who requested the document download. Optional attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocument2(id: string, behalf: boolean, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument2(id, behalf, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads a zip group of documents, content is organized by folder specified by request group policy
         * @param {DocumentDownloadGroupedRequest} [documentDownloadGroupedRequest] Metadata group and search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocumentsByGroup2(documentDownloadGroupedRequest?: DocumentDownloadGroupedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocumentsByGroup2(documentDownloadGroupedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the content of a document
         * @param {boolean} [replaceMetadata] Replace document and metadata flag. True if the new complex metadata and document will replace the existing, otherwise false
         * @param {AttachmentContentType} [type] 
         * @param {Array<Attachment>} [allAttachments] 
         * @param {Array<Attachment>} [childAttachments] 
         * @param {Attachment} [rootAttachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocument2(replaceMetadata?: boolean, type?: AttachmentContentType, allAttachments?: Array<Attachment>, childAttachments?: Array<Attachment>, rootAttachment?: Attachment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSaveDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocument2(replaceMetadata, type, allAttachments, childAttachments, rootAttachment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uploads the content of a document
         * @param {File} content file to upload
         * @param {string} documentType type of the document uploaded
         * @param {string} origin upload origin
         * @param {string} filename name of the document uploaded
         * @param {SimpleMetadata} complexMetadata 
         * @param {string} [ownerCode] owner of the document uploaded
         * @param {string} [source] source system name
         * @param {string} [status] status of the document uploaded
         * @param {string} [mimeType] mime-type of the document uploaded
         * @param {string} [size] content length of the file to upload
         * @param {Array<string>} [contactInfoList] contact data to notify information list&lt;string&gt;
         * @param {string} [expirationDate] document expiration date (dd/MM/yyyy)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocument2(content: File, documentType: string, origin: string, filename: string, complexMetadata: SimpleMetadata, ownerCode?: string, source?: string, status?: string, mimeType?: string, size?: string, contactInfoList?: Array<string>, expirationDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSaveDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument2(content, documentType, origin, filename, complexMetadata, ownerCode, source, status, mimeType, size, contactInfoList, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentContentProviderApi - factory interface
 * @export
 */
export const DocumentContentProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentContentProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Downloads a document content by document id
         * @param {string} id The id of the document to download
         * @param {boolean} behalf Flag indicating if the user is PG.
         * @param {string} [userId] User id who requested the document download. Optional attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument2(id: string, behalf: boolean, userId?: string, options?: any): AxiosPromise<object> {
            return localVarFp.downloadDocument2(id, behalf, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads a zip group of documents, content is organized by folder specified by request group policy
         * @param {DocumentDownloadGroupedRequest} [documentDownloadGroupedRequest] Metadata group and search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentsByGroup2(documentDownloadGroupedRequest?: DocumentDownloadGroupedRequest, options?: any): AxiosPromise<void> {
            return localVarFp.downloadDocumentsByGroup2(documentDownloadGroupedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the content of a document
         * @param {boolean} [replaceMetadata] Replace document and metadata flag. True if the new complex metadata and document will replace the existing, otherwise false
         * @param {AttachmentContentType} [type] 
         * @param {Array<Attachment>} [allAttachments] 
         * @param {Array<Attachment>} [childAttachments] 
         * @param {Attachment} [rootAttachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument2(replaceMetadata?: boolean, type?: AttachmentContentType, allAttachments?: Array<Attachment>, childAttachments?: Array<Attachment>, rootAttachment?: Attachment, options?: any): AxiosPromise<ResponseSaveDocumentResponse> {
            return localVarFp.updateDocument2(replaceMetadata, type, allAttachments, childAttachments, rootAttachment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads the content of a document
         * @param {File} content file to upload
         * @param {string} documentType type of the document uploaded
         * @param {string} origin upload origin
         * @param {string} filename name of the document uploaded
         * @param {SimpleMetadata} complexMetadata 
         * @param {string} [ownerCode] owner of the document uploaded
         * @param {string} [source] source system name
         * @param {string} [status] status of the document uploaded
         * @param {string} [mimeType] mime-type of the document uploaded
         * @param {string} [size] content length of the file to upload
         * @param {Array<string>} [contactInfoList] contact data to notify information list&lt;string&gt;
         * @param {string} [expirationDate] document expiration date (dd/MM/yyyy)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument2(content: File, documentType: string, origin: string, filename: string, complexMetadata: SimpleMetadata, ownerCode?: string, source?: string, status?: string, mimeType?: string, size?: string, contactInfoList?: Array<string>, expirationDate?: string, options?: any): AxiosPromise<ResponseSaveDocumentResponse> {
            return localVarFp.uploadDocument2(content, documentType, origin, filename, complexMetadata, ownerCode, source, status, mimeType, size, contactInfoList, expirationDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for downloadDocument2 operation in DocumentContentProviderApi.
 * @export
 * @interface DocumentContentProviderApiDownloadDocument2Request
 */
export interface DocumentContentProviderApiDownloadDocument2Request {
    /**
     * The id of the document to download
     * @type {string}
     * @memberof DocumentContentProviderApiDownloadDocument2
     */
    readonly id: string

    /**
     * Flag indicating if the user is PG.
     * @type {boolean}
     * @memberof DocumentContentProviderApiDownloadDocument2
     */
    readonly behalf: boolean

    /**
     * User id who requested the document download. Optional attribute.
     * @type {string}
     * @memberof DocumentContentProviderApiDownloadDocument2
     */
    readonly userId?: string
}

/**
 * Request parameters for downloadDocumentsByGroup2 operation in DocumentContentProviderApi.
 * @export
 * @interface DocumentContentProviderApiDownloadDocumentsByGroup2Request
 */
export interface DocumentContentProviderApiDownloadDocumentsByGroup2Request {
    /**
     * Metadata group and search filters
     * @type {DocumentDownloadGroupedRequest}
     * @memberof DocumentContentProviderApiDownloadDocumentsByGroup2
     */
    readonly documentDownloadGroupedRequest?: DocumentDownloadGroupedRequest
}

/**
 * Request parameters for updateDocument2 operation in DocumentContentProviderApi.
 * @export
 * @interface DocumentContentProviderApiUpdateDocument2Request
 */
export interface DocumentContentProviderApiUpdateDocument2Request {
    /**
     * Replace document and metadata flag. True if the new complex metadata and document will replace the existing, otherwise false
     * @type {boolean}
     * @memberof DocumentContentProviderApiUpdateDocument2
     */
    readonly replaceMetadata?: boolean

    /**
     * 
     * @type {AttachmentContentType}
     * @memberof DocumentContentProviderApiUpdateDocument2
     */
    readonly type?: AttachmentContentType

    /**
     * 
     * @type {Array<Attachment>}
     * @memberof DocumentContentProviderApiUpdateDocument2
     */
    readonly allAttachments?: Array<Attachment>

    /**
     * 
     * @type {Array<Attachment>}
     * @memberof DocumentContentProviderApiUpdateDocument2
     */
    readonly childAttachments?: Array<Attachment>

    /**
     * 
     * @type {Attachment}
     * @memberof DocumentContentProviderApiUpdateDocument2
     */
    readonly rootAttachment?: Attachment
}

/**
 * Request parameters for uploadDocument2 operation in DocumentContentProviderApi.
 * @export
 * @interface DocumentContentProviderApiUploadDocument2Request
 */
export interface DocumentContentProviderApiUploadDocument2Request {
    /**
     * file to upload
     * @type {File}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly content: File

    /**
     * type of the document uploaded
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly documentType: string

    /**
     * upload origin
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly origin: string

    /**
     * name of the document uploaded
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly filename: string

    /**
     * 
     * @type {SimpleMetadata}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly complexMetadata: SimpleMetadata

    /**
     * owner of the document uploaded
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly ownerCode?: string

    /**
     * source system name
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly source?: string

    /**
     * status of the document uploaded
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly status?: string

    /**
     * mime-type of the document uploaded
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly mimeType?: string

    /**
     * content length of the file to upload
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly size?: string

    /**
     * contact data to notify information list&lt;string&gt;
     * @type {Array<string>}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly contactInfoList?: Array<string>

    /**
     * document expiration date (dd/MM/yyyy)
     * @type {string}
     * @memberof DocumentContentProviderApiUploadDocument2
     */
    readonly expirationDate?: string
}

/**
 * DocumentContentProviderApi - object-oriented interface
 * @export
 * @class DocumentContentProviderApi
 * @extends {BaseAPI}
 */
export class DocumentContentProviderApi extends BaseAPI {
    /**
     * 
     * @summary Downloads a document content by document id
     * @param {DocumentContentProviderApiDownloadDocument2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentContentProviderApi
     */
    public downloadDocument2(requestParameters: DocumentContentProviderApiDownloadDocument2Request, options?: AxiosRequestConfig) {
        return DocumentContentProviderApiFp(this.configuration).downloadDocument2(requestParameters.id, requestParameters.behalf, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads a zip group of documents, content is organized by folder specified by request group policy
     * @param {DocumentContentProviderApiDownloadDocumentsByGroup2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentContentProviderApi
     */
    public downloadDocumentsByGroup2(requestParameters: DocumentContentProviderApiDownloadDocumentsByGroup2Request = {}, options?: AxiosRequestConfig) {
        return DocumentContentProviderApiFp(this.configuration).downloadDocumentsByGroup2(requestParameters.documentDownloadGroupedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the content of a document
     * @param {DocumentContentProviderApiUpdateDocument2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentContentProviderApi
     */
    public updateDocument2(requestParameters: DocumentContentProviderApiUpdateDocument2Request = {}, options?: AxiosRequestConfig) {
        return DocumentContentProviderApiFp(this.configuration).updateDocument2(requestParameters.replaceMetadata, requestParameters.type, requestParameters.allAttachments, requestParameters.childAttachments, requestParameters.rootAttachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads the content of a document
     * @param {DocumentContentProviderApiUploadDocument2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentContentProviderApi
     */
    public uploadDocument2(requestParameters: DocumentContentProviderApiUploadDocument2Request, options?: AxiosRequestConfig) {
        return DocumentContentProviderApiFp(this.configuration).uploadDocument2(requestParameters.content, requestParameters.documentType, requestParameters.origin, requestParameters.filename, requestParameters.complexMetadata, requestParameters.ownerCode, requestParameters.source, requestParameters.status, requestParameters.mimeType, requestParameters.size, requestParameters.contactInfoList, requestParameters.expirationDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentProviderApi - axios parameter creator
 * @export
 */
export const DocumentProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a document
         * @param {DeleteDocumentRequest} [deleteDocumentRequest] Search filters for documents to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument1: async (deleteDocumentRequest?: DeleteDocumentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/stream/document/deleteDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves metadata for a document
         * @param {DocumentBean} [documentBean] The document data to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument1: async (documentBean?: DocumentBean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/stream/document/saveDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentBean, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentProviderApi - functional programming interface
 * @export
 */
export const DocumentProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes a document
         * @param {DeleteDocumentRequest} [deleteDocumentRequest] Search filters for documents to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument1(deleteDocumentRequest?: DeleteDocumentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument1(deleteDocumentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves metadata for a document
         * @param {DocumentBean} [documentBean] The document data to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDocument1(documentBean?: DocumentBean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSaveDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDocument1(documentBean, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentProviderApi - factory interface
 * @export
 */
export const DocumentProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes a document
         * @param {DeleteDocumentRequest} [deleteDocumentRequest] Search filters for documents to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument1(deleteDocumentRequest?: DeleteDocumentRequest, options?: any): AxiosPromise<ResponseVoid> {
            return localVarFp.deleteDocument1(deleteDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves metadata for a document
         * @param {DocumentBean} [documentBean] The document data to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument1(documentBean?: DocumentBean, options?: any): AxiosPromise<ResponseSaveDocumentResponse> {
            return localVarFp.saveDocument1(documentBean, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDocument1 operation in DocumentProviderApi.
 * @export
 * @interface DocumentProviderApiDeleteDocument1Request
 */
export interface DocumentProviderApiDeleteDocument1Request {
    /**
     * Search filters for documents to delete
     * @type {DeleteDocumentRequest}
     * @memberof DocumentProviderApiDeleteDocument1
     */
    readonly deleteDocumentRequest?: DeleteDocumentRequest
}

/**
 * Request parameters for saveDocument1 operation in DocumentProviderApi.
 * @export
 * @interface DocumentProviderApiSaveDocument1Request
 */
export interface DocumentProviderApiSaveDocument1Request {
    /**
     * The document data to save
     * @type {DocumentBean}
     * @memberof DocumentProviderApiSaveDocument1
     */
    readonly documentBean?: DocumentBean
}

/**
 * DocumentProviderApi - object-oriented interface
 * @export
 * @class DocumentProviderApi
 * @extends {BaseAPI}
 */
export class DocumentProviderApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a document
     * @param {DocumentProviderApiDeleteDocument1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentProviderApi
     */
    public deleteDocument1(requestParameters: DocumentProviderApiDeleteDocument1Request = {}, options?: AxiosRequestConfig) {
        return DocumentProviderApiFp(this.configuration).deleteDocument1(requestParameters.deleteDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves metadata for a document
     * @param {DocumentProviderApiSaveDocument1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentProviderApi
     */
    public saveDocument1(requestParameters: DocumentProviderApiSaveDocument1Request = {}, options?: AxiosRequestConfig) {
        return DocumentProviderApiFp(this.configuration).saveDocument1(requestParameters.documentBean, options).then((request) => request(this.axios, this.basePath));
    }
}


